import { $api } from "../generated/client";

type UseCancellationRefundPreviewParams = {
  shopId: string;
  returnRequestId: string;
  enabled?: boolean;
};

/**
 * What cancelling the return would refund to the customer, read again each
 * time the confirmation opens (no cache: it depends on Shopify and Stripe).
 */
export default function useCancellationRefundPreview({
  shopId,
  returnRequestId,
  enabled = true,
}: UseCancellationRefundPreviewParams) {
  return $api.useQuery(
    "get",
    "/shops/{shopId}/return-requests/{returnRequestId}/cancellation-refund",
    { params: { path: { shopId, returnRequestId } } },
    // `enabled` goes in the 4th argument: the 3rd is the request init.
    // No retry: a failure shows at once as "cannot be checked".
    { enabled, staleTime: 0, gcTime: 0, retry: false },
  );
}
